
export default function TimePeriodView() {

    let startTime="";
    let endTime="";
    let breakHour="";
    let breakMin="";
    let remarks="";
    let showBreak=true;
    let hidePeriod=false;
    return {
        view: (vnode) => {
            let data=vnode.attrs.data;
            startTime=data.startTime;
           
            endTime=data.endTime;
            if(startTime==null){
                hidePeriod=true;
            }
            else{
                hidePeriod=false;
            }
            if(data.breakHour){
             let arr=data.breakHour.split(':');
             breakHour=Number(arr[0])+" hr";
             breakMin=Number(arr[1])==0?"": Number(arr[1])+" min";
             if((Number(arr[0])+Number(arr[1]))>0){
                showBreak=true;
             }else{
                showBreak=false;
             }
            }
            else{
                showBreak=false;
            }
            remarks=data.remarks;
            return [
                !hidePeriod &&  m('.d-grid.gap-2.d-sm-flex',m('span',startTime+" ~ "),m('span',endTime),
                showBreak && m('span',m('i.bi.bi-cup-fill')),
                showBreak && m('span',breakHour),
                showBreak && m('span',breakMin)
                ),
                hidePeriod && m('span','-')
            
            ]
        }
    }
}
